import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Dropdown, Form } from 'react-bootstrap';
import Logo from '../../assets/images/BlombosLogo.svg';
import PageHeader from '../../components/PageHeader';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { useSelector } from 'react-redux';
import { hasPermission } from '../../utils/common';
import {
  permissionsList,
  permissionsWithAssignedIds,
} from '../../api/constant';
import { createUserApi, getAllUsersApi } from '../../api/userApi';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';
import FileUploader from '../FileManager/FileUploader';
import ProtectedComponent from '../../common/ProtectedComponent';

export default function AddUserForm() {
  const {
    handleSubmit,
    formState: { errors, isSubmitted },
  } = useForm();
  const navigate = useNavigate();
  const [phone, setPhone] = useState('');
  const [selectedRole, setSelectedRole] = useState([]);
  const [selectedRoleId, setSelectedRoleId] = useState(0);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [qualification, setQualification] = useState('');
  const [specialization, setSpecialization] = useState('');
  const [workExperience, setWorkExperience] = useState('');
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);

  const [touchedFields, setTouchedFields] = useState({
    email: false,
    phone: false,
  });

  const permissionMap = useSelector(
    (state) => state.loginReducer?.permissionsMap,
  );
  const roleOptions = useSelector(
    (state) => state.loginReducer?.admin?.createUser?.roles,
  );

  const roleWithIds = useSelector(
    (state) => state.loginReducer?.admin?.createUser?.rolesWithAssignedIds,
  );

  const handleRoleChange = (event) => {
    const value = event.target.value;
    setSelectedRole(value);
    setSelectedRoleId(roleWithIds[value]);
  };

  // const isFormValid = () => {
  //   return firstName && lastName && email && phone && selectedRoleId > 0;
  // };

  const isFormValid = () => {
    const fieldsToValidate = [
      { value: firstName, maxLength: 50, isRequired: true },
      { value: lastName, maxLength: 50, isRequired: true },
      { value: email, maxLength: 50, isRequired: true },
      { value: qualification, maxLength: 50, isRequired: false },
      { value: specialization, maxLength: 50, isRequired: false },
      { value: workExperience, maxLength: 50, isRequired: false },
    ];

    const areFieldsValid = fieldsToValidate.every(
      ({ value, maxLength, isRequired }) => {
        return (
          (!isRequired || value.trim() !== '') &&
          (value.trim() === '' || !validateField(value, maxLength).isInvalid)
        );
      },
    );

    const phoneValid = validatePhoneNumber(phone);
    const emailValid = validateEmail(email);

    return areFieldsValid && phoneValid && emailValid && selectedRoleId > 0;
  };

  const validateField = (fieldValue, maxLength) => {
    const isInvalid = fieldValue.length > maxLength;
    return {
      isInvalid,
      errorMessage: isInvalid ? `Must not exceed ${maxLength} characters.` : '',
    };
  };

  const validatePhoneNumber = (phone) => {
    const phoneRegex = /^(?:\+91|91)?[6-9]\d{9}$/;
    return phoneRegex.test(phone);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const onSubmit = async (data) => {
    try {
      if (selectedRoleId > 0 && isFormValid()) {
        setIsSubmitDisabled(true);
        toast.promise(
          createUserApi({
            firstName,
            lastName,
            email,
            phoneNumber: phone,
            qualification,
            specialization,
            workExperience,
            roleAssignedId: selectedRoleId,
          }),
          {
            loading: 'Creating user...',
            success: (data) => {
              navigate('/view-users');
              return 'User created successfully!';
            },
            error: (err) => {
              setIsSubmitDisabled(false);
              // return 'Failed to create user';
              return (
                err?.response?.data?.message?.[0]?.message ??
                'Failed to create user'
              );
            },
            duration: 100,
          },
        );
      } else {
        alert('Please select at least one role.');
      }
    } catch (err) {}
  };

  return (
    <ProtectedComponent
      requiredPermission={
        permissionsWithAssignedIds[permissionsList.CreateUser]
      }
    >
      <div className="flex" style={{ alignItems: 'flex-start' }}>
        <div className="container-fluid" style={{ flex: '1 0 0' }}>
          <PageHeader
            HeaderText="View Users"
            Breadcrumb={[
              { name: 'Users', navigate: '/view-users' },
              { name: 'View Users', navigate: '/view-users' },
            ]}
          />
        </div>
        <button
          onClick={handleSubmit(onSubmit)}
          className="btn btn-primary"
          disabled={!isFormValid() || isSubmitDisabled}
          style={{ marginTop: '20px', marginRight: '20px' }}
        >
          Submit
        </button>
        <button
          onClick={() => navigate('/view-users')}
          className="btn btn-secondary"
          style={{ marginTop: '20px', marginRight: '20px' }}
        >
          Cancel
        </button>
      </div>

      <div className="theme-blush component-wrapper">
        <div className="registration-vertical-align-wrap">
          <div className="vertical-align-middle registration-form">
            <div style={{ padding: '15px' }}>
              {/* <div className="top">
                  <img
                    src={Logo}
                    alt="Blomboss Logo"
                    style={{ width: '150px', margin: '10px' }}
                  />
                </div> */}
              <Form>
                <div className="card">
                  <div className="header">
                    <p className="lead">General Information</p>
                  </div>
                  {/* <FileUploader buttonLabel ="Upload" inputId= "upload-btn" multiple /> */}
                  <div className="card_name_container">
                    <div className="form-group">
                      <label htmlFor="firstName">
                        First Name
                        <span className="mandatory_fields">*</span>
                      </label>
                      <input
                        required
                        type="text"
                        className={`form-control ${validateField(firstName, 50).isInvalid ? 'is-invalid' : ''}`}
                        id="firstName"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                      />
                      {validateField(firstName, 50).errorMessage && (
                        <span className="error">
                          {validateField(firstName, 50).errorMessage}
                        </span>
                      )}

                      {/* {errors.firstName && isSubmitted && (
                          <span className="error">
                            {errors.firstName.message}
                          </span>
                        )} */}
                    </div>
                    <div className="form-group">
                      <label htmlFor="lastName">
                        Last Name
                        <span className="mandatory_fields">*</span>
                      </label>
                      <input
                        required
                        type="text"
                        className={`form-control ${validateField(lastName, 50).isInvalid ? 'is-invalid' : ''}`}
                        id="lastName"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                      />

                      {validateField(lastName, 50).errorMessage && (
                        <span className="error">
                          {validateField(lastName, 50).errorMessage}
                        </span>
                      )}

                      {/* {errors.lastName && isSubmitted && (
                          <span className="error">
                            {errors.lastName.message}
                          </span>
                        )} */}
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">
                      Email address
                      <span className="mandatory_fields">*</span>
                    </label>
                    <input
                      required
                      type="email"
                      className={`form-control ${touchedFields.email && (validateField(email, 50).isInvalid || !validateEmail(email)) ? 'is-invalid' : ''}`}
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        setTouchedFields({ ...touchedFields, email: true });
                      }}
                    />

                    {touchedFields.email && (
                      <>
                        {validateField(email, 50).errorMessage && (
                          <span className="error">
                            {validateField(email, 50).errorMessage}
                          </span>
                        )}
                        {!validateEmail(email) && (
                          <span className="error">
                            Please enter a valid email address.
                          </span>
                        )}
                      </>
                    )}

                    {/*                       
                      {errors.email && isSubmitted && (
                        <span className="error">{errors.email.message}</span>
                      )} */}

                    <small id="emailHelp" className="form-text text-muted">
                      We'll never share your email with anyone else.
                    </small>
                  </div>
                  <div className="form-group">
                    <label htmlFor="phone">
                      Phone
                      <span className="mandatory_fields">*</span>
                    </label>
                    <PhoneInput
                      country={'in'}
                      value={phone}
                      onChange={(phone) => {
                        setPhone(phone);
                        setTouchedFields({ ...touchedFields, phone: true });
                      }}
                      inputProps={{
                        name: 'phone',
                        required: true,
                        autoFocus: true,
                        placeholder: 'Enter your phone number',
                      }}
                      disableDropdown={false}
                      onlyCountries={['in', 'us', 'ca', 'uk']}
                      disableCountryCode={false}
                    />

                    {touchedFields.phone && !validatePhoneNumber(phone) && (
                      <span className="error">
                        Please enter a valid phone number.
                      </span>
                    )}

                    {/* {isSubmitted && !phone && (
                        <span className="error">Phone number is required</span>
                      )} */}
                  </div>
                  <div className="form-group">
                    <label htmlFor="Qualification">Qualification</label>
                    <input
                      type="text"
                      className={`form-control ${validateField(qualification, 50).isInvalid ? 'is-invalid' : ''}`}
                      id="Qualification"
                      value={qualification}
                      onChange={(e) => setQualification(e.target.value)}
                    />
                    {validateField(qualification, 50).errorMessage && (
                      <span className="error">
                        {validateField(qualification, 50).errorMessage}
                      </span>
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="Specialization">Specialization</label>
                    <input
                      type="text"
                      className={`form-control ${validateField(specialization, 50).isInvalid ? 'is-invalid' : ''}`}
                      id="Specialization"
                      value={specialization}
                      onChange={(e) => setSpecialization(e.target.value)}
                    />
                    {validateField(specialization, 50).errorMessage && (
                      <span className="error">
                        {validateField(specialization, 50).errorMessage}
                      </span>
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="Workexperience">Work experience</label>
                    <input
                      type="text"
                      className={`form-control ${validateField(workExperience, 50).isInvalid ? 'is-invalid' : ''}`}
                      id="Workexperience"
                      value={workExperience}
                      onChange={(e) => setWorkExperience(e.target.value)}
                    />
                    {validateField(workExperience, 50).errorMessage && (
                      <span className="error">
                        {validateField(workExperience, 50).errorMessage}
                      </span>
                    )}
                  </div>
                  <div className="form-group user-role-form">
                    <label>
                      User Role
                      <span className="mandatory_fields">*</span>
                    </label>
                    <div className="input-group mb-3 dropdown-role">
                      <Dropdown
                        drop="down"
                        className="input-group-prepend dropdown"
                      >
                        <Dropdown.Toggle
                          variant="success"
                          as="div"
                          id="dropdown-basic"
                          className="hide-toggle"
                        >
                          <button
                            aria-haspopup="true"
                            className="btn btn-outline-secondary dropdown-toggle dropdown-toggle"
                            ngbdropdowntoggle=""
                            type="button"
                            aria-expanded="false"
                          >
                            Select Role
                          </button>
                        </Dropdown.Toggle>

                        <Dropdown.Menu as="div">
                          {Object.keys(roleOptions).map((role) => (
                            <Dropdown.Item
                              key={role}
                              onClick={() =>
                                handleRoleChange({ target: { value: role } })
                              }
                            >
                              {roleOptions[role]}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                      <input
                        aria-label="Text input with dropdown button"
                        className="form-control"
                        type="text"
                        value={selectedRole}
                        readOnly
                      />
                    </div>
                  </div>
                  <div>
                    {isSubmitted && selectedRole === 0 && (
                      <span className="error">
                        At least one role must be selected
                      </span>
                    )}
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </ProtectedComponent>
  );
}
